var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgClock(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 42 42",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M26.375 27.125 27.125 26.375 20.542 19.792V11.542H19.542V20.208ZM20 34.5Q17 34.5 14.375 33.354Q11.75 32.208 9.771 30.25Q7.792 28.292 6.646 25.646Q5.5 23 5.5 20Q5.5 17 6.646 14.375Q7.792 11.75 9.75 9.771Q11.708 7.792 14.354 6.646Q17 5.5 20 5.5Q23 5.5 25.625 6.646Q28.25 7.792 30.229 9.75Q32.208 11.708 33.354 14.354Q34.5 17 34.5 20Q34.5 23 33.354 25.625Q32.208 28.25 30.25 30.229Q28.292 32.208 25.646 33.354Q23 34.5 20 34.5ZM20 20Q20 20 20 20Q20 20 20 20Q20 20 20 20Q20 20 20 20Q20 20 20 20Q20 20 20 20Q20 20 20 20Q20 20 20 20ZM20 33.5Q25.583 33.5 29.542 29.542Q33.5 25.583 33.5 20Q33.5 14.417 29.542 10.458Q25.583 6.5 20 6.5Q14.417 6.5 10.458 10.458Q6.5 14.417 6.5 20Q6.5 25.583 10.458 29.542Q14.417 33.5 20 33.5Z",
    stroke: "#004466",
    strokeWidth: 2,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgClock);
export default __webpack_public_path__ + "static/media/clock.07db857e86a12a7d21004d0ea55daa1a.svg";
export { ForwardRef as ReactComponent };